class Service {
  constructor() {
    this._actived = null
    this._subscriptions = {}
    this._count = 0
    window.addEventListener('resize', this.resizeHandler.bind(this))
    document.body.addEventListener('click', this.clickHandler.bind(this))
  }
  clickHandler(...args) {
    if(this._actived && this._subscriptions[this._actived]) {
      this._subscriptions[this._actived].click(...args)
    }
  }
  resizeHandler(...args) {
    if(this._actived && this._subscriptions[this._actived]) {
      this._subscriptions[this._actived].resize(...args)
    }
  }
  subscription(handlers) {
    this._count ++
    this._subscriptions[this._count] = handlers
    this._actived = this._count
    return this._count
  }
  unsubscription(_id) {
    if (this._subscriptions[_id]) {
      delete this._subscriptions[_id]
    }
  }
  active(_id) {
    this._actived = _id
    if (this._subscriptions[_id] && this._subscriptions[_id].resize) {
      this._subscriptions[_id].resize()
    }
  }
}
const s = new Service()
export const service = s
